import React, { useContext } from "react";
import { useAnalytics, useAppNavigate } from "@commons-monorepo/index";
import styles from "./main-cover-1.module.css";
import { UiButton } from "@ui-monorepo/index";
import { useDataSlider } from "../../main-cover-hook";
import { MAIN_COVER_EVENTS } from "../../main-cover-events";
import WidgetContainer from "../../../widget-container";
import { ContentCoverContext } from "../../main-cover.context";

const MainCover1 = () => {
  const { config, isMobile, storeMetadata } = useContext(ContentCoverContext);
  const { enabled, enabled_button, text, text_button, position } =
  config.welcome;
  const { getCoverPreview } = useDataSlider();
  const [logEvent] = useAnalytics({ storeMetadata });
  const navigate = useAppNavigate();
  const cover = config.welcome.image;

  const scrollToAllProducts = () => {
    navigate("todos-los-productos", { relative: "path" });
    logEvent(MAIN_COVER_EVENTS.SELECT_WEB_BUY_NOW_BANNER);
  };

  return (
    <WidgetContainer className={styles.widgetContainer}>
      <div className={styles.mainCover1Container}>
        <div className={styles.wrapperCover1}>
          {cover.cover_image && isMobile &&
          <img
            className={styles.portrait}
            src={getCoverPreview(cover.cover_image)}
            alt={"slider-img"}
            loading='eager' />}


          {cover.web_cover && !isMobile &&
          <img
            className={styles.portrait}
            src={getCoverPreview(cover.web_cover)}
            alt={"slider-img"}
            loading='eager' />}


          {(enabled || enabled_button) &&
          <div className={`${styles[position]} ${styles.portraitActions}`}>
              <div className={styles.textsBox}>
                {enabled &&
              <div className={styles.texts}>
                    <p className={styles.welcomeText}>{text}</p>
                  </div>}

                {enabled_button &&
              <UiButton
                isFilled
                className={styles.cta}
                onClick={scrollToAllProducts}>

                    <div className={styles.sliderSellerBtnText}>
                      {text_button}
                    </div>
                  </UiButton>}

              </div>
            </div>}

        </div>
      </div>
    </WidgetContainer>);

};

export default MainCover1;